module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/admin/search-a2cd2e9660ef6dae86e2d68fbf37b5ed.svg&quot;;"